var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6605 2.02812L2.9605 7.93815C2.41802 8.35453 2.10001 8.9995 2.10001 9.68335V21.9C2.10001 22.5075 2.59249 23 3.20001 23H7.60001C8.20752 23 8.70001 22.5075 8.70001 21.9V16.4C8.70001 15.7925 9.19249 15.3 9.80001 15.3H14.2C14.8075 15.3 15.3 15.7925 15.3 16.4V21.9C15.3 22.5075 15.7925 23 16.4 23H20.8C21.4075 23 21.9 22.5075 21.9 21.9V9.68335C21.9 8.9995 21.582 8.35453 21.0395 7.93815L13.3395 2.02812C12.5495 1.42172 11.4506 1.42172 10.6605 2.02812Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a3041d4a12ae861000b8db237dcb6c21.svg";
export { ForwardRef as ReactComponent };